<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/5chap1#chap1"><i>To the Reader</i></a></p>
<p class="toc1"><a href="#/v1/6chap2#chap2"><i>Yonder Peasant, Who Is He?</i></a></p>
<p class="toc1"><a href="#/v1/8chap3#chap3"><i>A Tin Butterfly</i></a></p>
<p class="toc1"><a href="#/v1/10chap4#chap4"><i>The Blackguard</i></a></p>
<p class="toc1"><a href="#/v1/11chap5#chap5"><i>C’est le Premier Pas Qui Coûte</i></a></p>
<p class="toc1"><a href="#/v1/12chap6#chap6"><i>Names</i></a></p>
<p class="toc1"><a href="#/v1/14chap7#chap7"><i>The Figures in the Clock</i></a></p>
<p class="toc1"><a href="#/v1/16chap8#chap8"><i>Yellowstone Park</i></a></p>
<p class="toc1"><a href="#/v1/18chap9#chap9"><i>Ask Me No Questions</i></a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/19chap10#chap10">Image Gallery</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?636fd73a